/* eslint-disable @typescript-eslint/no-explicit-any */
import { submitHandler } from './submit-handler';
import { displayLoadingModal } from '../components/utils';
import { getCurrentFeatureCode } from '@/app/core/auth';
import { modalUtils } from '@/app/core';

export const submitProgram = async (
  model: Record<string, any>,
  programName: string,
  programId: string,
  draftId: string,
  history: any,
  closeModal: () => void,
  buildPath: (...paths: string[]) => string,
  setIsProcessing?: (processing: boolean) => void,
) => {
  const closeSubmitModal = displayLoadingModal(
    'Program submission is in progress. Please wait...',
  );
  await submitHandler(
    programName,
    getCurrentFeatureCode() || '',
    draftId,
    programId,
    model,
  )
    .then((saveProps) => {
      if (saveProps?.resultCode === 0) {
        modalUtils.showSuccessMessage(
          saveProps?.messages[0] || 'Submitted program successfully.',
          () => {
            history.push(buildPath('/dashboard?show=jobs'), 'EXIT');
          },
        );
      } else {
        modalUtils.showError('Unable to submit the program. Unknown error.');
      }
    })
    .catch((error) => {
      modalUtils.showError(error || 'Error while submitting the program');
    })
    .finally(() => {
      closeSubmitModal();
      closeModal();
      setIsProcessing && setIsProcessing(false);
    });
};
